let _hasLoggedInBefore = false;
export const hasLoggedInBefore = () => _hasLoggedInBefore;
export const setHasLoggedInBefore = (val) => {
  _hasLoggedInBefore = val;
};
